"use strict";

define('model/group',['underscore', './base', './person', './group.member'], function (_, BaseModel, PersonModel, GroupMember) {
  var Group = BaseModel.extend({
    urlRoot: '/rs/api/group',
    validation: {
      name: {
        required: true
      }
    },
    members: function members() {
      return GroupMember.createCollection('/rs/api/group/:id/member').params({
        id: this.id
      });
    }
  }, {
    all: function all(params) {
      return this.createCollection('/rs/api/group').addAdapter({
        preprocess: function preprocess(options) {
          options.data = _.extend({}, options.data, params);
        }
      });
    },
    collectionByCurrentUser: function collectionByCurrentUser() {
      this.createCollection('/rs/api/group/user/list');
    },
    IRB_BOARD: 'IRB_BOARD',
    IRB_ANALYST: 'IRB_ANALYST',
    IRB_ORGAPPROVER: 'IRB_ORGAPPROVER'
  });
  return Group;
});

